export default __webpack_public_path__ + "static/2_26-1--537b7324abbfb82f72a6953ef9dfdc05.png";